var _rect, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 24,
    viewBox: "0 0 141 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 141,
    height: 2,
    fill: "url(#paint0_linear_1_330)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 12,
    r: 9,
    fill: "url(#paint1_linear_1_330)",
    stroke: "#F2FDFF",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_330",
    x1: 154.846,
    y1: 10.8614,
    x2: 153.974,
    y2: 23.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#55A7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_330",
    x1: 77.1783,
    y1: 5.16868,
    x2: 61.9961,
    y2: 8.30747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#55A7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineGreen);
export default __webpack_public_path__ + "static/media/underlineGreen.e58aa94f22b0631b94bdc520244ae474.svg";
export { ForwardRef as ReactComponent };